import * as React from 'react';
import { FC } from 'react';

import { ILinkWidgetFragment } from 'generated/sanity-graphql';
import { isExternalLink } from 'utils/is-external-link';

import { LinksContainer, StyledLink } from './loyalty-links-widget.styled';

interface ILinksWidgetProps {
  links: ILinkWidgetFragment[];
}

const LoyaltyLinksWidget: FC<ILinksWidgetProps> = ({ links }: ILinksWidgetProps) => {
  if (!links.length) {
    return null;
  }

  return (
    <LinksContainer>
      {links.map((link, idx) =>
        link.link?.locale ? (
          <StyledLink
            to={link.link.locale}
            key={link._key ?? idx}
            target={isExternalLink(link.link.locale) ? '_blank' : '_self'}
          >
            {link.text?.locale}
          </StyledLink>
        ) : null
      )}
    </LinksContainer>
  );
};

export default LoyaltyLinksWidget;
